import cx from "classnames";

/** Small red unread indicator for Ask Puntt list and artifact rows. */
export function UnreadDot({
  testId,
  ariaLabel,
  className,
}: {
  testId: string;
  ariaLabel: string;
  className?: string;
}) {
  return (
    <span
      role="status"
      aria-label={ariaLabel}
      data-testid={testId}
      className={cx("size-2 shrink-0 rounded-full bg-puntt-red-9", className)}
    />
  );
}
